import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MdOutlineAttachMoney } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { FaMoneyBill1 } from "react-icons/fa6";

import './layout.css';

const EditSalaryLayouts = ({ children }) => {
  const location = useLocation();
  
  // Check if the current path is related to Provident Fund
  const isProvidentFundActive = location.pathname.startsWith("/provident-fund");

  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <FaMoneyBill1 className="leave-policy-icon" />
        Edit Salary Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="basic-salary-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/basic-salary"
              >
                <MdOutlineAttachMoney className="nav-icon" /> Basic Salary
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="provident-fund-link"
                className={`nav-link ${isProvidentFundActive ? 'active' : ''}`}
                to="/provident-fund"
              >
                <GiMoneyStack className="nav-icon" /> Provident Fund
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default EditSalaryLayouts;
